
import classes from "./Cart.module.css"
import React from 'react'

function Cart() {
  return (
    <div className={classes.CartMainDiv}>我的收藏</div>
  )
}

export default Cart